/* eslint-disable import/no-mutable-exports */

let contextExport;

if (typeof window !== "undefined" && window.Context) {
	contextExport = window.Context;
} else {
	contextExport = {};
}

export default contextExport;



// WEBPACK FOOTER //
// ./src/shared/util/Context.js